import { setShowJobSheetModal } from '../State/showJobSheetModal';

export default () => async (dispatch) => {

  dispatch(setShowJobSheetModal(false));
  
}